/* Badges are stable CSS overlays; classify images inserted by search/recommender. */
(() => {
  window.__ESAROMA_CARD_BADGES_VERSION__ = '20261006.overlay.1';
  const classify = (root) => {
    const media = root.matches?.('.product-card-media') ? [root] : [...root.querySelectorAll('.product-card-media')];
    media.forEach((node) => {
      if (node.dataset.cardPhoto === 'full' || node.closest('product-card[data-pack-card]')) return;
      const image = node.querySelector('.card-gallery img');
      if ([image?.src, image?.currentSrc, image?.dataset.maxResolution].join(' ').includes('-100ml-halo-2026')) node.classList.add('product-card-media--halo');
    });
  };
  classify(document);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node instanceof Element) classify(node);
    }));
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();
